import React from "react";

const MobileWidgets = () => {
  var informazioni = global.informazioni

  return (
    <div className="offcanvas-widget-area">
      <div className="off-canvas-contact-widget">
        <div className="header-contact-info">
          <ul className="header-contact-info__list">
            <li>
              <i className="fa fa-phone"></i>{" "}
              <a href={"tel://" + informazioni.phone.replace("(+39) ")}>{informazioni.phone} </a>
            </li>
            <li>
              <i className="fa fa-envelope"></i>{" "}
              <a href={informazioni.mail[0].link}>{informazioni.mail[0].value}</a>
            </li>
          </ul>
        </div>
      </div>
      {/*Off Canvas Widget Social Start*/}
      <div className="off-canvas-widget-social">
        <a href={informazioni.instagramLink} title="Instagram">
          <i className="fa fa-instagram"></i>
        </a>
        <a href={informazioni.facebookLink} title="Facebook">
          <i className="fa fa-facebook"></i>
        </a>
        <a href={informazioni.whatsappLink} title="WhatsApp">
          <i className="fa fa-whatsapp"></i>
        </a>
      </div>
      {/*Off Canvas Widget Social End*/}
    </div>
  );
};

export default MobileWidgets;
